import { render, staticRenderFns } from "./appendix-devices.vue?vue&type=template&id=2bdf22c6&scoped=true"
import script from "./appendix-devices.vue?vue&type=script&lang=js"
export * from "./appendix-devices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf22c6",
  null
  
)

export default component.exports